import React from "react";
import { Box, Stack, Typography, Chip, IconButton } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

export function SavedConfigurationCard({
  config,
  wings,
  parkingTypes, // ✅ Wing-specific types
  onRemove,
  onEdit,
}) {
  const wing = wings.find((w) => w.id === config.wingId);
  const unitType = wing?.unitTypes.find((ut) => ut.id === config.unitTypeId);
  const parkingType = parkingTypes.find((pt) => pt.id === config.parkingTypeId);

  if (!wing || !unitType || !parkingType) return null;

  return (
    <Box
      border="1px solid"
      borderColor="divider"
      borderRadius={2}
      p={2}
      mb={1.5}
      bgcolor="#fafbff"
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Stack direction="row" spacing={2} alignItems="center" minWidth={0}>
          <Box
            width={40}
            height={40}
            borderRadius={2}
            bgcolor="#fafbff"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <DirectionsCarIcon />
          </Box>

          <Box minWidth={0}>
            <Typography sx={{ fontSize: 14, fontWeight: 800 }} noWrap>
              {unitType.name}
              <Typography component="span" sx={{ mx: 1 }} color="text.secondary">
                —
              </Typography>
              <Typography component="span" sx={{ fontSize: 13 }} color="text.secondary">
                {parkingType.name}
              </Typography>
            </Typography>

         {config.isUpgradeEligible && (
  <Typography sx={{ fontSize: 12 }} color="text.secondary">
    Upgrade eligible
  </Typography>
)}
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
      <Chip
  size="small"
  label={config.isUpgrade ? "Upgrade" : "Included"}
  color={config.isUpgrade ? "warning" : "success"}
/>
          
          <IconButton 
            onClick={() => {
              console.log('✏️ EDIT CLICK!', config.id);
              if (typeof onEdit === 'function') {
                onEdit(config);
              } else {
                console.warn('⚠️ onEdit prop missing');
              }
            }} 
            color="primary"
          >
            <EditIcon />
          </IconButton>

          <IconButton onClick={() => onRemove(config.id)} color="error">
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
}
